(function () {
  var GRID = '.kitchen-gallery__grid[data-zoom="true"]';
  var IMAGE = '.kitchen-gallery__image';

  function buildItems(grid) {
    return Array.prototype.map.call(grid.querySelectorAll(IMAGE), function (el) {
      var src = el.getAttribute('data-photoswipe-src') || el.currentSrc || el.src;
      var w = parseInt(el.getAttribute('data-photoswipe-width'), 10);
      var h = parseInt(el.getAttribute('data-photoswipe-height'), 10);

      if (!w || !h) {
        w = el.naturalWidth || 1200;
        h = el.naturalHeight || 1200;
      }

      return {
        msrc: el.currentSrc || el.src,
        src: src,
        w: w,
        h: h,
        el: el
      };
    });
  }

  function open(grid, index) {
    var pswpElement = document.querySelector('.pswp');
    if (!pswpElement || typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') {
      return;
    }

    var items = buildItems(grid);

    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
      index: index,
      scaleMode: 'fit',
      captionEl: false,
      counterEl: false,
      shareEl: false,
      preloaderEl: false,
      fullscreenEl: false,
      zoomEl: false,
      history: false,
      closeOnScroll: false,
      pinchToClose: false,
      allowPanToNext: false,
      tapToToggleControls: false,
      getThumbBoundsFn: function (i) {
        var thumb = items[i].el;
        if (!thumb) return null;
        var rect = thumb.getBoundingClientRect();
        var scroll = window.pageYOffset || document.documentElement.scrollTop;
        return { x: rect.left, y: rect.top + scroll, w: rect.width };
      }
    });

    gallery.init();
  }

  function init(root) {
    (root || document).querySelectorAll(GRID).forEach(function (grid) {
      if (grid.dataset.kitchenGalleryInit === 'true') return;
      grid.dataset.kitchenGalleryInit = 'true';

      grid.querySelectorAll(IMAGE).forEach(function (img, i) {
        img.addEventListener('click', function () {
          open(grid, i);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
